// extracted by mini-css-extract-plugin
var _1 = "FileUpload-module_inputHidden__i26B7b";
var _2 = "FileUpload-module_inputLabel__g377ur";
var _3 = "FileUpload-module_textLabel__GU5JeC";
export { _1 as "inputHidden", _2 as "inputLabel", _3 as "textLabel" }
